export const MOCKUP_URL =
  'https://cdn.magicpatterns.com/uploads/9tGZjbegCCp22BweyBia6g/Mockup_DEUTSCHE.png'
